import { ProductBuyOptionsSerializer } from "web/types/serializers";

export const baseAffiliateAnalyticsConfig = (
    mainBuyOption: ProductBuyOptionsSerializer,
    productId: string
) =>
    ({
        href: mainBuyOption.affiliate_url,
        eventCategory: "oos-product-hero",
        eventAction: "click",
        eventCustomData: {
            buy_option_id: mainBuyOption.link_id.toString(),
            product_id: productId,
            retailer_slug: mainBuyOption.retailer_slug,
        },
    } as const);
